import React from 'react'

import { ComponentWithSubheader } from 'dash/shared'

import { AccountBilling } from './billing'
import Channel from './channel'
import Notification from './notification'
import Settings from './settings'
import TeamMember from './team'

export default class Account {
  static Billing = () => <ComponentWithSubheader path={['My Account']} label="Billing" component={AccountBilling} />
  static Channel = Channel
  static Notification = Notification
  static Settings = Settings
  static TeamMember = TeamMember
}
